<div class="spinner" *ngIf="loading">
  <app-spinner size="full" [loading]="loading"></app-spinner>
</div>

<div class="m-2">
  <div>
    <p class="modal-card-title">
      {{ 'voluntary-change.additional.title' | translate }}
    </p>
    <p class="has-text-grey mb-3 mt-1">
      {{ 'voluntary-change.additional.subtitle' | translate }}
    </p>
  </div>

  <!-- FORMS -->
  <div *ngFor="let item of passengers$ | async as passengers; index as i">
    <app-passenger-docsa-information
      [names]="passengersInfo[i].firstName + ' ' + passengersInfo[i].lastName"
      [id]="i"
      [submitted]="submitted"
      (docsa)="validDocsa($event, i)"
      [PassengerInformation]="item"
      [passengerDoc]="passengersInfo"
    ></app-passenger-docsa-information>
  </div>

  <div class="columns">
    <!-- Back button -->
    <div class="column">
    <div class="column is-narrow">
      <app-input-submit
        inputText="{{ 'shared.save-and-continue' | translate }}"
        [disabled]="!canSubmit"
        type="submit"
        (clickButton)="submit()"
      ></app-input-submit>
    </div>
  </div>
</div>
